import React, { useState, useEffect } from "react";
import { DeclararUC } from "./modalDeclararUC";
import { DeclararUCRet } from "./modalDeclararUCRet";
import { ActualizarCamposComercio } from "./modalActualizarCamposComercio";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import useTable from "../../useTable";
import axios from "axios";
import { formatMoneda } from "../../../util/varios";
import { Toasts } from "../../toasts";
import { SearchInput } from "../../../ui/inputs/Input";

const headCells = [
	{
		id: "idcomercio",
		label: "CODIGO",
		width: "10px",
		textAlign: "center",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
	},
	{
		id: "ritm",
		label: "RITM",
		width: "80px",
		textAlign: "center",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
	},
	{
		id: "rif",
		label: "RIF",
		width: "80px",
		textAlign: "center",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
	},
	{
		id: "nombre",
		label: "NOMBRE",
		width: "300px",
		textAlign: "center",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
	},
	{
		id: "reprelegal",
		label: "CEDULA",
		width: "150px",
		textAlign: "center",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
	},
	{
		id: "accion",
		label: "OPCIONES",
		width: "120px",
		textAlign: "center",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
	},
];

function TablaComercioDeclaraUC(props) {
	const [titulo1] = useState();
	const [msg1] = useState();
	const [mostrar2, setMostrar2] = useState(false);
	const [mostrar5, setMostrar5] = useState(false);
	const [mostrar6, setMostrar6] = useState(false);
	const [idComercio, setIdComercio] = useState(0);
	const [activate, setActivate] = useState(false);
	const factorCambio = JSON.parse(localStorage.getItem("factorCambio"));
	const [operacion, setOperacion] = useState(0);
	const [comercio, setComercio] = useState();
	const [persona, setPersona] = useState();
	const [configCome, setConfigCome] = useState();
	const [actividadxCome, setActividadxCome] = useState();
	const [idUsuario, setIdUsuario] = useState();
	const [deuda, setDeuda] = useState();
	const [historico, setHistorico] = useState();
	const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
	const [fechaSistema, setFechaSistema] = useState(
		localStorage.getItem("fechasistema")
	);
	const [anioActu] = useState(localStorage.getItem("anioactu"));
	const [deshabilitado, setDeshabilitado] = useState(false);
	const permiso = JSON.parse(localStorage.getItem("accdeclaraciones"));
	const [indice, setIndice] = useState(-1);
	const [mensaje, setMensaje] = useState({
		mostrar: false,
		titulo: "",
		texto: "",
		icono: "",
	});
	const [records, setRecords] = useState([]);
	const [totDeuda, setTotDeuda] = useState("0,00");
	const [toast, setToast] = useState({
		mostrar: false,
		mensaje: "",
		titulo: "",
	});
	const [filterFn, setFilterFn] = useState({
		fn: (items) => {
			return items;
		},
	});
	let token = localStorage.getItem("jwtToken");
	let op = require("../../../../src/modulos/datos");
	const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
		useTable(records, headCells, filterFn);

	const handleSearch = (e) => {
		let target = e.target;

		setFilterFn({
			fn: (items) => {
				if (target.value === "") {
					return items;
				} else {
					return items.filter((x) => {
						if (
							(x.idcomercio.includes(target.value) === null
								? ""
								: x.idcomercio.includes(target.value)) ||
							(x.ritm === null
								? ""
								: x.ritm.toLowerCase().includes(target.value.toLowerCase())) ||
							(x.rif === null
								? ""
								: x.rif.toLowerCase().includes(target.value.toLowerCase())) ||
							(x.nombre === null
								? ""
								: x.nombre
									.toLowerCase()
									.includes(target.value.toLowerCase())) ||
							(x.reprelegal === null ? "" : x.reprelegal.includes(target.value))
						) {
							return x;
						}
					});
				}
			},
		});
	};

	const seleccionarComercios = () => {
		setActivate(true);
		setRecords([]);
		let endpoint = `${op.conexion}/api/industria/comercios`;
		axios
			.get(endpoint, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then((response) => {
				if (response.status == 200) {
					if (response.data.length > 0) {
						setRecords(response.data);
					}
				}
				setActivate(false);
			})
			.catch((error) => {
				setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});
				setActivate(false);
			});
	};

	const seleccionarConfiguracion = () => {
		let endpoint = op.conexion + "/api/industria/configuracionindustria";
		axios
			.get(endpoint, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then((response) => {
				if (response.status == 200) {
					setConfigCome(response.data);
					if (response.data.valorutMulta === null) {
						if (response.data.factormulta === 2) {
							setMensaje({
								mostrar: true,
								titulo: "Información",
								texto:
									"El valor de la unidad tributaria para el año " +
									anioActu +
									" no esta definido",
								icono: "informacion",
							});
						} else if (response.data.factormulta > 2) {
							let tipo = response.data.factormulta - 3;
							setMensaje({
								mostrar: true,
								titulo: "Información",
								texto:
									"El valor del " +
									(tipo === 0
										? "Petro"
										: tipo === 1
											? "Sueldo Minimo"
											: tipo === 2
												? "UCAMP"
												: "") +
									" para el año " +
									anioActu +
									" en el mes en curso no esta definido",
								icono: "informacion",
							});
						}
					}
				}
			})
			.catch((error) => {
				setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});
				setActivate(false);
			});
	};

	const SelectComercio = (idcomercio) => {
		let endpoint = `${op.conexion}/api/industria/comerciopersona/${idcomercio}`;
		axios
			.get(endpoint, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then((response) => {
				if (response.status == 200) {
					if (response.data.idcomercio > 0) {
						setComercio(response.data);
						setPersona({
							cedula: response.data.cedula,
							nombres: response.data.nombres,
							apellidos: response.data.apellidos,
							correoe: response.data.correoe,
							tlf1: response.data.tlf1,
							tlf2: response.data.tlf2,
							fnacimiento: response.data.fnacimiento,
							nacionalidad: response.data.nacionalidad,
							sexo: response.data.sexo,
							direccion: response.data.direccionp,
						});
						if (espiritu === 0 || espiritu === 9) {
							/* if (response.data.actualizado) { */
								let idactividad =
									response.data.idactividad === null
										? 0
										: response.data.idactividad;
								let idinmueble =
									response.data.idinmueble === null
										? 0
										: response.data.idinmueble;
								let esagente =
									response.data.esagentereten === null
										? false
										: response.data.esagentereten;
								SelectActividad(idcomercio, idactividad);
							/* } else {
								setMostrar2(true);
							} */
						} else {
							let idactividad =
								response.data.idactividad === null
									? 0
									: response.data.idactividad;
							let idinmueble =
								response.data.idinmueble === null
									? 0
									: response.data.idinmueble;
							let esagente =
								response.data.esagentereten === null
									? false
									: response.data.esagentereten;
							SelectActividad(idcomercio, idactividad);
						}
					} else {
						setMensaje({
							mostrar: true,
							titulo: "ERROR",
							texto: "error al cargar el comercio",
							icono: "error",
						});
						setActivate(false);
					}
				}
			})
			.catch((error) => {
				setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});
				setActivate(false);
			});
	};

	const SelectActividad = (idcomercio, idactividad) => {
		let endpoint = `${op.conexion}/api/industria/actividad?idactividad=${idactividad}`;
		axios
			.get(endpoint, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then((response) => {
				if (response.status == 200) {
					if (response.data !== "") {
						SelectActividadComercio(
							idcomercio,
							parseInt(JSON.parse(localStorage.getItem("efiscalanio")))
						);
					} else {
						SelectActividadComercio(
							idcomercio,
							parseInt(JSON.parse(localStorage.getItem("efiscalanio")))
						);
					}
				}
			})
			.catch((error) => {
				setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});
				setActivate(false);
			});
	};

	const SelectActividadComercio = (idcomercio, anio) => {
		let endpoint = `${op.conexion}/api/industria/actividadxcomercio?idcomercio=${idcomercio}&anio=${anio}`;
		axios
			.get(endpoint, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then((response) => {
				if (response.status == 200) {
					if (response.data !== 0) {
						var axc = [];
						for (let i = 0; i < response.data.length; i++) {
							axc.push({
								alicuota: response.data[i].alicuota,
								codigoactividad: response.data[i].codigoactividad,
								codigociu: response.data[i].codigociu,
								descripcion: response.data[i].descripcion,
								idactividad: response.data[i].idactividad,
								minimo: response.data[i].minimo,
							});
						}
						setActividadxCome(axc);
					} else {
						setActividadxCome("");
					}
					SelectDeudaC(idcomercio);
				}
			})
			.catch((error) => {
				setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});
				setActivate(false);
			});
	};

	const SelectDeudaC = (idcomercio) => {
		let endpoint;
		if (espiritu === 100) {
			endpoint = `${op.conexion}/api/industria/deudacomerciors?idcomercio=${idcomercio}&fecha=${fechaSistema}&espiritu=${espiritu}&tipounid=${1}`;
		} else {
			endpoint = `${op.conexion}/api/industria/deudacomercio?idcomercio=${idcomercio}&fecha=${fechaSistema}&espiritu=${espiritu}&tipounid=${1}`;
		}

		axios.get(endpoint, {
			headers: {
				"x-access-token": `${token}`,
				"Content-Type": "application/json",
			},
		}).then(function (response) {
			if (response.status == 200) {
				var mesactu = (new Date(fechaSistema).getMonth() + 1).toString().padStart(2, 0);
				var deu = [];
				var his = [];
				var totdeu = parseFloat(0.0);
				for (let i = 0; i < response.data.length; i++) {
					if (response.data[i].fechapago === null) {
						if (response.data[i].nombredeuda === 'deudacomercio') {
							totdeu = totdeu + parseFloat(response.data[i].mondeu) + parseFloat(response.data[i].intmoradeu) + parseFloat(response.data[i].recargodeu) + parseFloat(response.data[i].multa);
							deu.push({
								anio: response.data[i].anio,
								mes: response.data[i].mes.replace("'", "").replace("'", ""),
								monto: response.data[i].mondeu,
								intereses: response.data[i].intmoradeu,
								recargo: response.data[i].recargodeu,
								multa: response.data[i].multa,
								retenciones: response.data[i].retencion,
								credito: response.data[i].acreditacion,
								totalperi: response.data[i].subtotal,
								status: response.data[i].estatus,
								idfac: response.data[i].idfact,
								nummes: response.data[i].nmes,
								estatusfac: response.data[i].estatusfac,
								tipotransaccion: response.data[i].tipotransaccion,
							});
						} else if (parseInt(response.data[i].anio) < parseInt(anioActu) || (parseInt(response.data[i].anio) === parseInt(anioActu) && parseInt(response.data[i].nmes) < parseInt(mesactu))){
							totdeu = totdeu + parseFloat(response.data[i].mondeu) + parseFloat(response.data[i].intmoradeu) + parseFloat(response.data[i].recargodeu) + parseFloat(response.data[i].multa);
							deu.push({
								anio: response.data[i].anio,
								mes: response.data[i].mes.replace("'", "").replace("'", ""),
								monto: response.data[i].mondeu,
								intereses: response.data[i].intmoradeu,
								recargo: response.data[i].recargodeu,
								multa: response.data[i].multa,
								retenciones: response.data[i].retencion,
								credito: response.data[i].acreditacion,
								totalperi: response.data[i].subtotal,
								status: response.data[i].estatus,
								idfac: response.data[i].idfact,
								nummes: response.data[i].nmes,
								estatusfac: response.data[i].estatusfac,
								tipotransaccion: response.data[i].tipotransaccion,
							});
						}

					} else {
						his.push({
							anio: response.data[i].anio,
							mes: response.data[i].mes.replace("'", "").replace("'", ""),
							monto: response.data[i].mondeu,
							intereses: response.data[i].intmoradeu,
							recargo: response.data[i].recargodeu,
							multa: response.data[i].multa,
							descuento: response.data[i].mondescue,
							recibo: response.data[i].numreci,
							fechapago: response.data[i].fechapago,
							status: response.data[i].estatus,
							idfac: response.data[i].idfact,
							estatusfac: response.data[i].estatusfac,
							tipotransaccion: response.data[i].tipotransaccion,
						});
					}
				}
				setTotDeuda(formatMoneda(totdeu.toString().replace(".", ","), ",", ".", 2));
				setDeuda(deu);
				setHistorico(his);
			}
			setActivate(false);
			if (espiritu === 100){
				setMostrar6(true);
			} else {
				setMostrar5(true);	
			}
			
		})
			.catch(function (error) {
				setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});
				setActivate(false);
			});
	};

	const cerrarModalActualizar = () => {
		setComercio();
		setActividadxCome();
		setPersona();
		if (espiritu === 100){
			setMostrar6(false);
		} else {
			setMostrar5(false);	
		}
		renderizar();
	};

	const validarActuComercio = () => {
		if (operacion === 4) {
			setComercio();
			if (espiritu === 100){
				setMostrar6(false);
			} else {
				setMostrar5(false);	
			}
			return;
		}
		if (operacion === 1) {
			setIdComercio(0);
		}
		setComercio();
		setPersona();
		if (espiritu === 100){
			setMostrar6(false);
		} else {
			setMostrar5(false);	
		}
		window.location.href = "/comercio";
	};
	const renderizar = () => {
		seleccionarComercios();
	};
	const validarActuCamposComercio = (actu) => {
		setComercio();
		setPersona();
		setMostrar2(false);
		if (actu) {
			realizarDeclaracion1(idComercio, indice);
		} else {
			setActivate(false);
			setMensaje({
				mostrar: true,
				titulo: "Información",
				texto: "Debe actualizar el correo para poder declarar.",
				icono: "informacion",
			});
		}
	};

	const realizarDeclaracion1 = (id) => {
		setDeshabilitado(false);
		setOperacion(1);
		setActivate(true);
		setDeshabilitado(false);
		setActivate(true);
		SelectComercio(id);
	};

	const realizarDeclaracion = (id, index, permiso) => (event) => {
		event.preventDefault();
		if (permiso === "1") {
			setIdComercio(id);
			setIndice(index);
			setDeshabilitado(false);
			setOperacion(1);
			setActivate(true);
			SelectComercio(id);
		} else {
			setToast({
				mostrar: true,
				titulo: "Notificación",
				mensaje: "No posee permiso para Declarar",
			});
		}
	};

	const cerrarToast = () => {
		setToast({
			...toast,
			mostrar: false,
		});
	};

	const cerrar = () => {
		props.setTabla(0);
	};

	

	useEffect(() => {
		let obj = JSON.parse(localStorage.getItem("post"));
		setFechaSistema(obj.fechasistema);
		setIdUsuario(obj.idusuario);
		setEspiritu(obj.espiritu);
		seleccionarComercios();
		seleccionarConfiguracion();
	}, []);

	return (
		<div className="col-8 m-0 p-2 border rounded mx-auto mt-5">
			<header className="col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top azulGradiant text-light">
				<h3 className="fw-bold m-0">Gestion de Declaraciones Juradas</h3>
				<a type="button" onClick={cerrar} className="text-light fw-bold fs-6">
					Salir <i className="fas fa-times ms-2"></i>
				</a>
			</header>
			<div className="col-6 col-lg-4 m-0 my-2 p-0">
				<SearchInput
					placeholder="Buscar"
					onChange={handleSearch}
				/>
			</div>
			<div className="col-12 m-0 p-0">
				<TblContainer>
					<TblHead />

					<tbody>
						{records &&
							recordsAfterPagingAndSorting().map((item, index) => (
								<tr key={item.idcomercio} style={{ padding: "0" }}>
									<td
										className="align-baseline"
										style={{ textAlign: "center", width: "10px" }}
									>
										{item.idcomercio}
									</td>
									<td
										className="align-baseline"
										style={{ textAlign: "center", width: "80px" }}
									>
										{item.ritm}
									</td>
									<td
										className="align-baseline"
										style={{ textAlign: "center", width: "80px" }}
									>
										{item.rif}
									</td>
									<td
										className="align-baseline"
										style={{ textAlign: "left", width: "300px" }}
									>
										{item.nombre}
									</td>
									<td
										className="align-baseline"
										style={{ textAlign: "center", width: "80px" }}
									>
										{item.reprelegal}
									</td>
									<td
										align="center"
										className="align-baseline"
										style={{ textAlign: "center", width: "100px" }}
									>
										<button
											onClick={realizarDeclaracion(
												item.idcomercio,
												index,
												permiso.toString().substring(0, 1)
											)}
											title="Gestionar Declaración"
											className={
												permiso.toString().substring(0, 1) === "1"
													? "btn btn-sm btn-info rounded-pill"
													: "btn btn-sm btn-secondary rounded-pill"
											}
										>
											<i className="fas fa-edit">Declarar</i>{" "}
										</button>
									</td>
								</tr>
							))}
					</tbody>
				</TblContainer>
				<TblPagination />
			</div>
			<DeclararUC
				show={mostrar5}
				titulo={titulo1}
				mensaje={msg1}
				onHideCancela={cerrarModalActualizar}
				onHideAcepta={validarActuComercio}
				comercio={comercio}
				representante={persona}
				tabdeuda={deuda}
				tabpago={historico}
				tabactixcomer={actividadxCome}
				deshabilitado={deshabilitado ? deshabilitado : undefined}
				declaweb={configCome ? configCome.declaweb.toString() : "false"}
				config={configCome}
				idusuario={idUsuario}
				operacion={operacion}
				totdeuda={totDeuda}
				factorCambio={factorCambio?.valor}
			/>
			<DeclararUCRet
				show={mostrar6}
				titulo={titulo1}
				mensaje={msg1}
				onHideCancela={cerrarModalActualizar}
				onHideAcepta={validarActuComercio}
				comercio={comercio}
				representante={persona}
				tabdeuda={deuda}
				tabpago={historico}
				tabactixcomer={actividadxCome}
				deshabilitado={deshabilitado ? deshabilitado : undefined}
				declaweb={configCome ? configCome.declaweb.toString() : "false"}
				config={configCome}
				idusuario={idUsuario}
				operacion={operacion}
				totdeuda={totDeuda}
				factorCambio={factorCambio?.valor}
			/>
			<ActualizarCamposComercio
				show={mostrar2}
				titulo={titulo1}
				mensaje={msg1}
				onHideCancela={cerrarModalActualizar}
				onHideAceptaActuCampo={validarActuCamposComercio}
				comercio={comercio}
				representante={persona}
				tabactixcomer={actividadxCome}
				declaweb={configCome ? configCome.declaweb.toString() : "false"}
				operacion={operacion}
			/>
			<Mensaje
				mensaje={mensaje}
				onHide={() => {
					setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
				}}
			/>
			<Dimmer active={activate} inverted></Dimmer>
			<Toasts
				show={toast.mostrar}
				titulo={toast.titulo}
				mensaje={toast.mensaje}
				onHideCancela={cerrarToast}
			/>
		</div>
	);
}
export default TablaComercioDeclaraUC;